import React, { createContext, useContext, useState, ReactNode } from 'react';

interface Bounds {
  swLat: number;
  swLng: number;
  neLat: number;
  neLng: number;
}

interface MarkerDetail {
  type: string;
  iidx: number;
  item_code: string;
  prc: number;
  pnu: number;
  pyeong: number;
  area: number;
  date: string;
  lat: number;
  lng: number;
  specialCondition: string;
  specialItems: string;
}
export interface MapFilterContextProps {
  markerHidden: string[];
  setMarkerHidden: React.Dispatch<React.SetStateAction<string[]>>;
  mapType: string;
  zoomLevel: number;
  latLng: { lat: number; lng: number } | null;
  overlayType: string;
  setOverlayType: React.Dispatch<React.SetStateAction<string>>;
  setMapType: (type: string) => void;
  setZoomLevel: (value: number) => void;
  setLatLng: (latLng: { lat: number; lng: number }) => void;
  geomData: [number, number][] | null;
  setGeomData: React.Dispatch<React.SetStateAction<[number, number][] | null>>;
  setPolygonCenter: React.Dispatch<
    React.SetStateAction<[number, number] | null>
  >;
  polygonCenter: [number, number] | null;
  measureType: string;
  setMeasureType: React.Dispatch<React.SetStateAction<string>>;
  measureYN: boolean;
  setMeasureYN: React.Dispatch<React.SetStateAction<boolean>>;
  minPrc: number;
  setMinPrc: React.Dispatch<React.SetStateAction<number>>;
  maxPrc: number;
  setMaxPrc: React.Dispatch<React.SetStateAction<number>>;
  minDeposit: number;
  setMinDeposit: React.Dispatch<React.SetStateAction<number>>;
  maxDeposit: number;
  setMaxDeposit: React.Dispatch<React.SetStateAction<number>>;
  minMonthlyRent: number;
  setMinMonthlyRent: React.Dispatch<React.SetStateAction<number>>;
  maxMonthlyRent: number;
  setMaxMonthlyRent: React.Dispatch<React.SetStateAction<number>>;
  saleItemType: string;
  setSaleItemType: React.Dispatch<React.SetStateAction<string>>;
  itemCategory: string;
  setItemCategory: React.Dispatch<React.SetStateAction<string>>;
  startDate: string;
  setStartDate: React.Dispatch<React.SetStateAction<string>>;
  endDate: string;
  setEndDate: React.Dispatch<React.SetStateAction<string>>;
  isApply: boolean;
  setIsApply: React.Dispatch<React.SetStateAction<boolean>>;
  roadViewLatLng: { lat: number; lng: number } | null;
  setRoadViewLatLng: React.Dispatch<
    React.SetStateAction<{ lat: number; lng: number } | null>
  >;
  selectedItemInfo: any;
  setSelectedItemInfo: React.Dispatch<React.SetStateAction<any>>;
  onPublicPrice: boolean;
  setOnPublicPrice: React.Dispatch<React.SetStateAction<boolean>>;
  listLoading: boolean;
  setListLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isTotalPrice: boolean;
  setIsTotalPrice: React.Dispatch<React.SetStateAction<boolean>>;
  isPyeonPrice: boolean;
  setIsPyeonPrice: React.Dispatch<React.SetStateAction<boolean>>;
  onFullRoadView: boolean;
  setOnFullRoadView: React.Dispatch<React.SetStateAction<boolean>>;
  fullRoadViewMarker: any;
  setFullRoadViewMarker: React.Dispatch<React.SetStateAction<any>>;
  markerSelectedIidx: number;
  setMarkerSelectedIidx: React.Dispatch<React.SetStateAction<number>>;
  markerType: string;
  setMarkerType: React.Dispatch<React.SetStateAction<string>>;
  regionModalOn: boolean;
  setRegionModalOn: React.Dispatch<React.SetStateAction<boolean>>;
  selectedItemInfo2: any;
  setSelectedItemInfo2: React.Dispatch<React.SetStateAction<any>>;
  markerDetail: MarkerDetail | null;
  setMarkerDetail: React.Dispatch<React.SetStateAction<MarkerDetail | null>>;
}

const MapFilterContext = createContext<MapFilterContextProps | undefined>(
  undefined,
);

export const MapFilterProvider = ({ children }: { children: ReactNode }) => {
  const [mapType, setMapType] = useState('ROADMAP');
  const [overlayType, setOverlayType] = useState('');
  const [zoomLevel, setZoomLevel] = useState(3);
  const [markerHidden, setMarkerHidden] = useState(['realDeal', 'auction']);
  const [latLng, setLatLng] = useState<{ lat: number; lng: number } | null>({
    lat: 37.4934705,
    lng: 127.0142285,
  });
  const [geomData, setGeomData] = useState<[number, number][] | null>([]);
  const [polygonCenter, setPolygonCenter] = useState<[number, number] | null>(
    null,
  );
  const [measureType, setMeasureType] = useState('');
  const [measureYN, setMeasureYN] = useState(false);
  const [minPrc, setMinPrc] = useState(0);
  const [maxPrc, setMaxPrc] = useState(100000000000);
  const [minDeposit, setMinDeposit] = useState(0);
  const [maxDeposit, setMaxDeposit] = useState(100000000000);
  const [minMonthlyRent, setMinMonthlyRent] = useState(0);
  const [maxMonthlyRent, setMaxMonthlyRent] = useState(100000000000);
  const [saleItemType, setSaleItemType] = useState('A,C,D');
  const [itemCategory, setItemCategory] = useState('A,B,C,D,E,F,G,H,I,J');
  const [startDate, setStartDate] = useState('2020-01-01');
  const [endDate, setEndDate] = useState('2025-01-01');
  const [isApply, setIsApply] = useState(false);
  const [roadViewLatLng, setRoadViewLatLng] = useState<{
    lat: number;
    lng: number;
  } | null>(null);
  const [selectedItemInfo, setSelectedItemInfo] = useState<any>({
    iidx: 0,
    b_idx: 0,
    type: '',
    lat: 0,
    lng: 0,
  });
  const [selectedItemInfo2, setSelectedItemInfo2] = useState<any>({
    iidx: 0,
    b_idx: 0,
    type: '',
    lat: 0,
    lng: 0,
    itemCode: '',
    status: '',
    specialCondition: '',
    specialItems: '',
  });
  const [onPublicPrice, setOnPublicPrice] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const [isTotalPrice, setIsTotalPrice] = useState(true);
  const [isPyeonPrice, setIsPyeonPrice] = useState(false);
  const [onFullRoadView, setOnFullRoadView] = useState(false);
  const [fullRoadViewMarker, setFullRoadViewMarker] = useState<any>(null);
  const [markerSelectedIidx, setMarkerSelectedIidx] = useState<number>(0);
  const [markerType, setMarkerType] = useState('A,P,E,S');
  const [regionModalOn, setRegionModalOn] = useState(false);
  const [markerDetail, setMarkerDetail] = useState<MarkerDetail | null>(null);
  return (
    <MapFilterContext.Provider
      value={{
        markerDetail,
        setMarkerDetail,
        selectedItemInfo2,
        setSelectedItemInfo2,
        regionModalOn,
        setRegionModalOn,
        markerType,
        setMarkerType,
        markerSelectedIidx,
        setMarkerSelectedIidx,
        fullRoadViewMarker,
        setFullRoadViewMarker,
        onFullRoadView,
        setOnFullRoadView,
        markerHidden,
        setMarkerHidden,
        overlayType,
        setOverlayType,
        mapType,
        zoomLevel,
        latLng,
        setMapType,
        setZoomLevel,
        setLatLng,
        geomData,
        setGeomData,
        setPolygonCenter,
        polygonCenter,
        measureType,
        setMeasureType,
        measureYN,
        setMeasureYN,
        minPrc,
        setMinPrc,
        maxPrc,
        setMaxPrc,
        minDeposit,
        setMinDeposit,
        maxDeposit,
        setMaxDeposit,
        minMonthlyRent,
        setMinMonthlyRent,
        maxMonthlyRent,
        setMaxMonthlyRent,
        saleItemType,
        setSaleItemType,
        itemCategory,
        setItemCategory,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        isApply,
        setIsApply,
        roadViewLatLng,
        setRoadViewLatLng,
        selectedItemInfo,
        setSelectedItemInfo,
        onPublicPrice,
        setOnPublicPrice,
        listLoading,
        setListLoading,
        isTotalPrice,
        setIsTotalPrice,
        isPyeonPrice,
        setIsPyeonPrice,
      }}
    >
      {children}
    </MapFilterContext.Provider>
  );
};

export const useMapFilterContext = () => {
  const context = useContext(MapFilterContext);
  if (!context) {
    throw new Error('MapFilterContext must be used within a MapProvider');
  }
  return context;
};
